import { render } from "./SecondNavBar.vue?vue&type=template&id=307a8464"
import script from "./SecondNavBar.vue?vue&type=script&lang=js"
export * from "./SecondNavBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__